"use strict";
/** state: Final **/
/** family: Radio **/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var lodash_1 = require("lodash");
var React = require("react");
var Fieldset_1 = require("../Fieldset");
var Input_1 = require("../Input");
var Radio_1 = require("../Radio");
var CLASS_NAME = 'i-radio-group';
var RadioGroup = (function (_a) {
    var checked = _a.checked, className = _a.className, disabled = _a.disabled, inline = _a.inline, legend = _a.legend, legendHidden = _a.legendHidden, mode = _a.mode, name = _a.name, onChange = _a.onChange, options = _a.options, readOnly = _a.readOnly, restProps = __rest(_a, ["checked", "className", "disabled", "inline", "legend", "legendHidden", "mode", "name", "onChange", "options", "readOnly"]);
    var _b;
    var handleChange = function (e) {
        var target = e.target;
        var targetIndex = target.parentNode.getAttribute('data-index');
        var updatedOptions = options;
        updatedOptions[targetIndex].checked = target.checked;
        onChange && onChange(e, updatedOptions);
    };
    var checkedOption = lodash_1.find(options, function (option) { return option.value === checked; });
    return (React.createElement(Fieldset_1.Fieldset, __assign({ className: classNames(CLASS_NAME, className, (_b = {
                'btn-group': mode === Radio_1.RadioMode.Switch
            },
            _b[CLASS_NAME + "--switch"] = mode === Radio_1.RadioMode.Switch,
            _b)), disabled: disabled, legend: legend, legendHidden: legendHidden }, restProps), readOnly ? (React.createElement(Input_1.Input, { type: Input_1.Input.Type.Text, className: classNames(CLASS_NAME, className), name: name, readOnly: true, value: checkedOption && checkedOption.label })) : (options.map(function (option, i) { return (React.createElement(Radio_1.Radio, { checked: checked && option.value === checked, "data-index": i, disabled: disabled, icon: option.icon, iconName: option.iconName, isInline: mode !== Radio_1.RadioMode.Switch && inline, key: i, label: option.label, labelHidden: option.labelHidden, mode: mode, name: name, onChange: handleChange, value: option.value })); }))));
});
exports.RadioGroup = RadioGroup;
RadioGroup.Mode = Radio_1.RadioMode;
RadioGroup.defaultProps = {
    mode: Radio_1.RadioMode.Radio,
};
//# sourceMappingURL=RadioGroup.js.map